/** Maximum file size for an .xlsx/.xlsm import (200 MB). Its tables stream,
 *  and the picker keeps only a sheet's first cells, so the file itself (held
 *  once for the picker, once for an import beside it) is what bounds memory. */
export const MAX_EXCEL_SIZE = 200 * 1024 * 1024;

/** .xls, .xlsb and .ods have no streaming reader: a sheet is read whole, and
 *  40 MB of workbook peaked near 1 GB. */
export const MAX_LEGACY_EXCEL_SIZE = 25 * 1024 * 1024;

/** Sample size for CSV sniffing and preview (1 MB). */
export const SAMPLE_SIZE = 1_000_000;
